<template>
  <div class="branch">
    <v-subheader v-if="!isLoadingBranch">{{ branchName }}</v-subheader>

    <v-container v-if="!isLoadingBranch && !branchNotFound" fluid>
      <v-row dense>
        <v-col cols="auto" v-if="isLoadingBranch">
          <v-progress-circular size="32" color="primary darken-4" indeterminate></v-progress-circular>
        </v-col>

        <v-col v-else v-for="card in returnCards" :key="card.name" :cols="cardDimensions.flex">
          <v-card
            class="pt-2"
            hover
            shaped
            ripple
            :to="{ name: card.name, params: { branchId: $route.params.branchId }}"
          >
            <v-row justify="center">
              <v-avatar size="54px" color="primary darken-4">
                <v-icon large dark>{{ card.icon }}</v-icon>
              </v-avatar>
            </v-row>

            <v-card-title
              class="d-block text-truncate text-center grey--text font-weight-bold text-subtitle-2 py-3"
              v-text="card.title"
            ></v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container v-show="branchNotFound">
      <v-row justify="center" align="center">
        <v-col cols="auto">
          <v-card color="white" class="pa-8" light elevation="2" :width="cardWidth">
            <div class="d-flex justify-center grey--text">
              <v-icon size="150">mdi-cancel</v-icon>
            </div>

            <div class="text-center title grey--text">
              <span class="font-weight-black">Branch</span> not available
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Branch",
  data() {
    return {
      isLoadingBranch: false
    };
  },

  components: {},

  methods: {
    async getBranch() {
      var branchId = this.$route.params.branchId;
      this.isLoadingBranch = true;

      await this.$store.dispatch("getBranch", branchId).finally(() => {
        this.isLoadingBranch = false;
      });
    }
  },

  watch: {
    $route() {
      this.getBranch();
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$store.commit("setBranchVendor");
    this.$store.commit("setOnBranch");
    next();
  },

  mounted() {
    this.getBranch();
  },

  computed: {
    cards() {
      return [
        {
          title: "Products",
          icon: "mdi-tag-multiple",
          name: "products",
          vendorOnly: false,
          private: true
        },
        {
          title: "Orders",
          icon: "mdi-file-document-edit",
          name: "orders",
          vendorOnly: false,
          private: true
        },
        {
          title: "Sales",
          icon: "mdi-text-box-check",
          name: "sales",
          vendorOnly: false,
          private: true
        },
        {
          title: "Staff",
          icon: "mdi-account-multiple",
          name: "staff",
          vendorOnly: true,
          private: true
        },
        {
          title: "Activity",
          icon: "mdi-history",
          name: "activity",
          vendorOnly: false,
          private: true
        },
        {
          title: "Analyses",
          icon: "mdi-chart-line",
          name: "analyses",
          priviliged: true,
          vendorOnly: true,
          private: true
        },
        {
          title: "Contacts",
          icon: "mdi-contacts",
          name: "contacts",
          priviliged: true,
          vendorOnly: true,
          private: true
        }
        // {
        //   title: "About",
        //   icon: "mdi-information",
        //   name: "about"
        // }
      ];
    },

    cardDimensions() {
      const nameType = this.$vuetify.breakpoint.name;
      var value = 0;

      switch (nameType) {
        case "xs":
          value = { flex: 6, imgHeight: "108px" };
          break;
        case "sm":
        case "md":
          value = { flex: 4, imgHeight: "200px" };
          break;
        case "lg":
        case "xl":
          value = { flex: 3, imgHeight: "200px" };
          break;

        default:
          value = { flex: 3, imgHeight: "200px" };
      }

      return value;
    },

    branchNotFound() {
      return this.$store.state.branches.branchNotFound;
    },

    branchName() {
      return this.$store.state.branches.branch.name;
    },

    cardWidth() {
      var name = this.$vuetify.breakpoint.name;

      if (name === "xs") {
        return "99vw";
      } else {
        return "45vw";
      }
    },

    isAuthorized2() {
      return this.$store.getters.isAuthorized2;
    },

    isAuthorizedVendor() {
      return (
        this.isAuthorized2 && this.$store.state.user.user_type === "Vendor"
      );
    },

    returnCards() {
      return this.cards.filter(card => {
        if (card.private) {
          if (card.vendorOnly & !card.priviliged) {
            if (this.isAuthorizedVendor) return card;
          } else if (card.priviliged) {
            if (
              this.isAuthorizedVendor ||
              (this.isAuthorized2 && this.$store.state.user.is_priviliged)
            )
              return card;
          } else if (this.isAuthorized2 && !card.priviliged) return card;
        } else return card;
      });
    }
  }
};
</script>

<style>
</style>